import React from "react";

import { Badge } from "../../../../../components/Badge";
import {
  activityColumnAlign,
  CORPORATE_ACTION_LOCK_REASON,
  EMPTY_CELL,
} from "./constants";
import { buildCorporateActionDisplay } from "./corporateActionDisplay";
import { CorporateActionItemProps } from "./types";
import {
  ActionNote,
  Cell,
  DetailsInline,
  DetailsStack,
  InstrumentExchange,
  InstrumentSymbol,
  KebabAlign,
  LockedChip,
  MutedText,
  PositionStack,
  Row,
  TypeBadge,
} from "./styles";

export const CorporateActionRow: React.FC<CorporateActionItemProps> = ({
  entry,
}) => {
  const {
    dateText,
    typeLabel,
    positionText,
    stateLabel,
    stateVariant,
    stateNote,
    detailsText,
  } = buildCorporateActionDisplay(entry);

  return (
    <Row>
      <Cell>{dateText}</Cell>
      <Cell>
        <TypeBadge $tone="neutral">{typeLabel}</TypeBadge>
      </Cell>
      <Cell>
        <PositionStack>
          <InstrumentSymbol>{positionText}</InstrumentSymbol>
          {entry.instrument?.exchange && (
            <InstrumentExchange>{entry.instrument.exchange}</InstrumentExchange>
          )}
        </PositionStack>
      </Cell>
      <Cell>
        <DetailsStack>
          <DetailsInline>
            {detailsText === null ? (
              <MutedText>{EMPTY_CELL}</MutedText>
            ) : (
              <span>{detailsText}</span>
            )}
            <Badge variant={stateVariant} style="soft" size="small">
              {stateLabel}
            </Badge>
          </DetailsInline>
          {stateNote && <ActionNote>{stateNote}</ActionNote>}
        </DetailsStack>
      </Cell>
      <Cell $align={activityColumnAlign("quantity")}>
        <MutedText>{EMPTY_CELL}</MutedText>
      </Cell>
      <Cell $align={activityColumnAlign("amount")}>
        <MutedText>{EMPTY_CELL}</MutedText>
      </Cell>
      <Cell>
        <KebabAlign>
          <LockedChip
            role="note"
            title={CORPORATE_ACTION_LOCK_REASON}
            aria-label={CORPORATE_ACTION_LOCK_REASON}
          >
            Locked
          </LockedChip>
        </KebabAlign>
      </Cell>
    </Row>
  );
};
